
  <div *ngIf="!loading" class="row">
    <div class="col-md-12">
      <dx-data-grid [dataSource]="dataSource"
                    [wordWrapEnabled]="true"
                    [showRowLines]="true"
                    [showBorders]="true"
                    [masterDetail]="{ enabled: true, template: 'docDetailTemplate' }"
                    (onToolbarPreparing)="onToolbarPreparing($event)">
        <dxo-sorting mode="single">
        </dxo-sorting>
        <dxo-paging [pageSize]="20"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true"
                   [allowedPageSizes]="[10, 20, 50]"
                   [showNavigationButtons]="true">
        </dxo-pager>

        <dxo-search-panel placeholder="Suche..." [width]="200" [visible]="true"></dxo-search-panel>

        <div *dxTemplate="let data of 'searchBarTemplateVon'">
          <div class="toolBarTemplateContainer">
            <div class="dx-field">
              <div class="dx-field-label">Von:</div>
              <div class="dx-field-value">
                <dx-date-box [(value)]="von"
                             [width]="150"
                             class="toolBarTemplateItem"
                             (valueChange)="changeValue($event)">
                </dx-date-box>
              </div>
            </div>
          </div>
        </div>
        <div *dxTemplate="let data of 'searchBarTemplateBis'">
          <div class="toolBarTemplateContainer">
            <div class="dx-field">
              <div class="dx-field-label">Bis:</div>
              <div class="dx-field-value">
                <dx-date-box [(value)]="bis"
                             [width]="150"
                             class="toolBarTemplateItem"
                             (valueChange)="changeValue($event)">
                </dx-date-box>
              </div>
            </div>
          </div>
        </div>

        <div *dxTemplate="let doc of 'docDetailTemplate'">
          <div class="row">
            <div class="col-md-2">
              <strong>{{doc.data.forEntityType}}, alte ID:</strong>
            </div>
            <div class="col-md-9">
              <span>{{doc.data.alteId}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <strong>Alter Pfad:</strong>
            </div>
            <div class="col-md-9">
              <span>{{doc.data.oldPfad}}</span>
            </div>
          </div>
        </div>

        <dxi-column type="buttons">
          <dxi-button hint="Download"
                      icon="glyphicon glyphicon-download"
                      [onClick]="cloneDownloadClick"></dxi-button>
          <dxi-button hint="Vorschau"
                      icon="glyphicon glyphicon-eye-open"
                      [onClick]="cloneVorschauClick"></dxi-button>
        </dxi-column>
        <dxi-column dataField="title" caption="Bezeichnung"></dxi-column>
        <dxi-column dataField="fileName" caption="Dateiname"></dxi-column>
        <dxi-column [width]="150" alignment="center" dataField="date" caption="Datum"></dxi-column>
      </dx-data-grid>

    </div>

    <dx-popup class="popup"
              *ngIf="isToShow"
              [showTitle]="true"
              title="Dokumentenvorschau"
              [height]="'90%'"
              [width]="'80%'"
              [dragEnabled]="false"
              [hideOnOutsideClick]="false"
              (onHidden)="onHiddenPopup($event)"
              [(visible)]="vorschauPopupVisible">
      <div *dxTemplate="let data of 'content'">

        <cz-document-viewer-archive *ngIf="vorschauPopupVisible" [fileName]="fileName"></cz-document-viewer-archive>

      </div>

      <dxi-popup-toolbar-item widget="dxButton"
                        location="after"
                        toolbar="bottom"
                        [options]="{
            text: 'Ok',
            onClick: hidePopup
        }">
      </dxi-popup-toolbar-item>

    </dx-popup>
  </div>
